<template>
  <el-dialog
    title="找回密码"
    :visible.sync="forgetPasswordDialogVisible"
    :close-on-click-modal="false"
    width="50%"
    :before-close="closeForgetPasswordDialog"
  >
    <div class="cre-all">
      <div class="cre-all-d">
        <span class="cre-all-sp"><span class="cre-xing">*</span>用户名：</span>
        <el-input
          type="text"
          class="cre-all-inp"
          style="width: 60%"
          v-model="forgetPasswordData.userName"
          placeholder="请输入用户名"
        >
        </el-input>
      </div>
	  <span class="cre-all-d">审核用户输入负责人手机号，企业用户输入用户电话(新注册企业，默认用户电话为公司负责人手机)</span>
      <div class="cre-all-d">
        <span class="cre-all-sp"
          ><span class="cre-xing">*</span>手机号：</span
        >
        <el-input
          type="text"
          class="cre-all-inp"
          style="width: 60%"
          v-model="forgetPasswordData.emergencyContactNumber"
          placeholder="输入手机号"
        >
        </el-input>
        <el-button
          type="primary"
          v-show="!isShowSendValidateCode"
          @click="sendValidateCode"
          >发送验证码</el-button
        >
        <el-button
          type="primary"
          v-show="isShowSendValidateCode"
          @click="sendValidateCode"
          disabled
        >
          {{ sendValidateCodeCount }}s
        </el-button>
      </div>
      <div class="cre-all-d">
        <span class="cre-all-sp"><span class="cre-xing">*</span>新密码：</span>
        <el-input
          show-password
          class="cre-all-inp"
          style="width: 60%"
          v-model="forgetPasswordData.newPassword"
          placeholder="请输入新密码"
          v-on:input="checkPassword"
        >
        </el-input>
        <span style="color:red;" v-if="isCheckPassword"
          >密码不能少于6位，必须包含数字、小写字母、大写字母以及特殊字符</span
        >
      </div>
      <div class="cre-all-d">
        <span class="cre-all-sp"
          ><span class="cre-xing">*</span>确认密码：</span
        >
        <el-input
          show-password
          class="cre-all-inp"
          style="width: 60%"
          v-model="forgetPasswordData.confirmPassword"
          placeholder="请输入确认密码"
        >
        </el-input>
      </div>
      <div class="cre-all-d">
        <span class="cre-all-sp"><span class="cre-xing">*</span>验证码：</span>
        <el-input
          type="text"
          class="cre-all-inp"
          style="width: 60%"
          v-model="forgetPasswordData.code"
          placeholder="请输入验证码"
        >
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeForgetPasswordDialog">取 消</el-button>
      <el-button type="primary" @click="forgetPassword">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    forgetPasswordDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forgetPasswordData: {
        userName: "",
        newPassword: "",
        confirmPassword: "",
        emergencyContactNumber: "",
        code: "",
      },
      isCheckPassword: false,
      isShowSendValidateCode: false,
      sendValidateCodeCount: 60,
      sendValidateCodeTimer: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.sendValidateCodeTimer);
  },
  methods: {
    closeForgetPasswordDialog() {
      this.forgetPasswordData = {
        userName: "",
        newPassword: "",
        emergencyContactNumber: "",
        code: "",
      };
      this.isCheckPassword = false;
      this.isShowSendValidateCode = false;
      clearInterval(this.sendValidateCodeTimer);
      this.$emit("update:forgetPasswordDialogVisible", false);
    },
    forgetPassword() {
      if (!this.forgetPasswordData.userName) {
        this.$message.error("请输入用户名");
        return;
      }
      if (!this.forgetPasswordData.emergencyContactNumber) {
        this.$message.error("请输入负责人手机号");
        return;
      }
      if (!this.forgetPasswordData.newPassword) {
        this.$message.error("请输入新密码");
        return;
      }
      if (!this.forgetPasswordData.confirmPassword) {
        this.$message.error("请输入确认密码");
        return;
      }
      if (
        this.forgetPasswordData.confirmPassword !==
        this.forgetPasswordData.newPassword
      ) {
        this.$message.error("两次密码不一致，请重写输入");
        return;
      }
      const passwordReg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,30}$/;
      if (!passwordReg.test(this.forgetPasswordData.newPassword)) {
        this.$message.error(
          "密码不能少于6位，必须包含数字、小写字母、大写字母以及特殊字符"
        );
        return;
      }
      // console.log(this.forgetPasswordData);
      let loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          "/api/services/app/User/UserResetPassword",
          this.forgetPasswordData
        )
        .then((res) => {
          if (res.data.success) {
            loading.close();
            this.closeForgetPasswordDialog();
            this.$message({
              message: "密码已找回，请重新登录",
              type: "success",
            });
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    checkPassword() {
      let passwordReg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,30}$/;
      if (!passwordReg.test(this.forgetPasswordData.newPassword)) {
        this.isCheckPassword = true;
      } else {
        this.isCheckPassword = false;
      }
    },
    sendValidateCode() {
      if (
        !/^1[23456789]\d{9}$/.test(this.forgetPasswordData.emergencyContactNumber)
      ) {
        this.$message.error("手机号格式错误");
        return;
      }
      this.$http
        .post("/api/services/app/User/SendMsg", {
          name: this.forgetPasswordData.userName,
          value: this.forgetPasswordData.emergencyContactNumber,
        })
        .then((res) => {
          if (res.data.success) {
            const TIME_COUNT = 60;
            if (!this.sendValidateCodeTimer) {
              this.isShowSendValidateCode = true;
              this.sendValidateCodeTimer = setInterval(() => {
                if (
                  this.sendValidateCodeCount > 0 &&
                  this.sendValidateCodeCount <= TIME_COUNT
                ) {
                  this.sendValidateCodeCount--;
                } else {
                  this.isShowSendValidateCode = false;
                  clearInterval(this.sendValidateCodeTimer);
                  this.sendValidateCodeTimer = null;
                }
              }, 1000);
            }
          }
        });
    },
  },
  watch: {
    forgetPasswordDialogVisible(val) {
      this.$emit("update:forgetPasswordDialogVisible", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.cre-all {
  display: inline-block;
  width: 100%;

  .cre-all-d {
    margin: 0 3% 30px 0;

    .cre-all-sp {
      font-size: 14px;
      color: #333333;
      margin-bottom: 10px;
      display: inline-block;
      float: left;
      line-height: 40px;

      .cre-xing {
        color: #ff0000;
      }
    }

    .cre-all-inp {
      width: 100%;
    }
  }
}
</style>
